import classes from './ServicesList.module.css';

import LogoImage from './LogoImage.jsx';

import { rows } from '../util/helpers.jsx';

function ServicesList({services}) {

  const limit = 5;

  if (services.length < 1) {
    return;
  }

  return (
    <div className={classes.services}>
      <h2>List of Services</h2>
        {services.map((service) => (
          <div className={classes.service}>
            <span>
              <LogoImage
                title={service.title}
                logo_contents={service.icon_contents}
                logo_filetype={service.icon_filetype}
                url={service.website}
              />
            </span>
            <span>
              <p>{service.title}</p>
              <p>Description</p>
              <textarea
                id="services-description"
                name="services-description"
                rows={rows(service.description, limit)}
                cols={60}
                readonly
                value={service.description}
              />
            </span>
          </div>
        ))}
    </div>
  );
}

export default ServicesList;
